import React from 'react';
import { Route, Routes } from 'react-router-dom';

import About from './pages/About/About.jsx';
import Contact from './pages/Contact/Contact.jsx';
import Projects from './pages/Projects/Projects.jsx';
import Resume from './pages/Resume/Resume.jsx';
import AdminLogin from './pages/Admin/AdminLogin';
import Blog from './pages/Blog/Blog.jsx';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfUse from './components/legal/TermsOfUse';

const Routing = () => {
  return (
    <Routes>
      {/* Strona główna */}
      <Route path="/" element={<About />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/Projects" element={<Projects />} />
      <Route path="/Resume" element={<Resume />} />
      <Route path="/Blog" element={<Blog />} />

      {/* policy */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />

      {/* Panel administracyjny */}
      <Route path="/admin/login" element={<AdminLogin />} />
    </Routes>
  );
};

export default Routing;
